import { render, staticRenderFns } from "./BlockVideos.vue?vue&type=template&id=c2272c2a&"
import script from "./BlockVideos.vue?vue&type=script&lang=js&"
export * from "./BlockVideos.vue?vue&type=script&lang=js&"
import style0 from "./BlockVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports